import reactUpdate, {Spec} from 'immutability-helper';

import {assert} from 'Asserts';
import Editor from 'Editor';
import {isStructuredTableNotePart} from 'notebook/notes/groups/util/assertIsStructuredTableNotePart';
import {getTablePlugin} from 'notebook/notes/plugins/getTablePlugin';
import {FullTableMap} from 'notebook/tables/excess/Evaluator';
import {getTableFromNotePart, getTableNotePartIndex} from 'notebook/tables/store/selectors/TableSelectors';
import {Table} from 'notebook/tables/TableConstants';
import TableUtil from 'notebook/tables/TableUtil';
import {isPlainTable} from 'notebook/TypePredicates';
import {Note, NotePart} from 'notebook/util/NoteUtilConstants';

export function getNotePartSpecFromTable(table: Table, notePart: NotePart): Spec<NotePart> {
  const plugin = getTablePlugin(notePart);
  // Neither the table or structured table plugins use this editor instance, so it does not need to be real.
  return plugin.setContent.call({} as Editor, {
    table,
  }) as Spec<NotePart>;
}

export function updateNoteWithTableMap(tableMap: FullTableMap, note: Note): Note {
  const itemUpdates: {[i: number]: Spec<NotePart>} = {};
  for (let i = 0; i < note.noteParts.length; i++) {
    const notePart = note.noteParts[i];
    if (isPlainTable(notePart) || isStructuredTableNotePart(notePart)) {
      const oldTable = getTableFromNotePart(notePart).table;

      const newTable = tableMap[oldTable.name];
      if (oldTable === newTable) {
        continue;
      }
      if (TableUtil.isInvalidOpWithWarn(oldTable, newTable, {})) {
        return note;
      }

      itemUpdates[i] = getNotePartSpecFromTable(newTable, notePart);
    }
  }
  return reactUpdate(note, {noteParts: itemUpdates});
}

export function updateTableInNote(note: Note, table: Table): Note {
  const notePartIndex = getTableNotePartIndex(note, table.name);
  assert(notePartIndex != null, `Note part index not found for ${table.name}`);
  const notePart = note.noteParts[notePartIndex];
  const updatedNotePartSpec = getNotePartSpecFromTable(table, notePart);
  return reactUpdate(note, {
    noteParts: {[notePartIndex]: updatedNotePartSpec},
  });
}
